<template lang="pug">
  main.contact#main
    .hero
      img.hero-image(:src='hero_image.url', :alt='hero_image.alt')
      .hero-text-wrapper
        prismic-rich-text(:field='title')
        prismic-rich-text(:field='description')
    section
      if (infoBoxes)
        #contact-info
          .info-box(v-for='info in infoBoxes')
            h2 {{ info.info_type }}
            a(:href="'tel:+1-' + info.info_value", v-if='info.info_type === "Call Us"') {{ info.info_value }}
            a(:href="'mailto:' + info.info_value", v-if='info.info_type === "Email Us"') {{ info.info_value }}
      .contact-form(v-html="form")
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {
      title: null,
      description: null,
      hero_image: '',
      infoBoxes: [],
      formTitle: null,
      form: null,
      metadata: {
        title: null,
        description: null,
        socialTitle: null,
        socialDescription: null,
        socialImage: null
      }
    }
  },
  metaInfo () {
    return {
      title: this.metadata.title,
      titleTemplate: '%s - Progressive Plant Research',
      meta: [
        { name: 'description', content: this.metadata.description },
        { property: 'og:title', content: this.metadata.socialTitle, template: '%s - Progressive Plant Research' },
        { property: 'og:description', content: this.metadata.socialDescription },
        { property: 'og:image', content: this.metadata.socialImage },
        { name: 'twitter:title', content: this.metadata.socialTitle, template: '%s - Progressive Plant Research' },
        { name: 'twitter:description', content: this.metadata.socialDescription },
        { name: 'twitter:image', content: this.metadata.socialImage }
      ]
    }
  },
  methods: {
    getContent (uid) {
      this.$prismic.client.getSingle('contact')
        .then((document) => {
          if (document) {
            this.title = document.data.hero_title
            this.description = document.data.hero_description
            this.hero_image = document.data.hero_image
            this.infoBoxes = document.data.info_box
            this.formTitle = document.data.form_title
            this.form = document.data.form
            this.metadata.title = document.data.metadata_title
            this.metadata.description = document.data.metadata_description
            this.metadata.socialTitle = document.data.metadata_social_title
            this.metadata.socialDescription = document.data.metadata_social_description
            this.metadata.socialImage = document.data.metadata_social_image.url
          } else {
            this.$router.push({ name: 'not-found' })
          }
        })
    }
  },
  created () {
    this.getContent(this.$route.params.uid)
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent(to.params.uid)
    next()
  }
}
</script>

<style lang="stylus">
@import '../styles/helpers/variables.styl'
@import '../styles/components/hero.styl'

.contact
  #contact-info
    align-items center
    display flex
    justify-content center
    margin-bottom 3rem
    width 100%
    .info-box
      text-align center
      h2, p
        width 100%
      h2
        color gray
        margin-bottom 1rem
      &:nth-child(2)
        margin-left 7rem
  .contact-form
    margin 0 auto
    width 100%
  form
    display flex
    flex-direction column
    flex-wrap wrap
    height 24rem
    width 100%
    input, label, select
      width 45%
    input, select, textarea
      font-family $font-primary
      font-size 16px
    label
      margin 1rem 0
    input
      border-radius 5px
      border 1px solid $gray-tint
      height 2rem
      &:nth-child(7)
        margin-bottom: 4.56rem
      &:last-child
        background-color $brown
        border-radius 5px
        color white
        font-family $font-primary
        font-size 16px
        height 2.5rem
        width 6rem
        transition ease-in-out 0.2s
        transition-timing-function cubic-bezier(.17,.67,.83,.67)
        -webkit-appearance none
        &:hover
          background-color $brown-shade
          color white
          cursor pointer
    select
      background-color $white
      border 1px solid $gray-tint
      border-radius 5px
      height 2.2rem
    textarea
      border-radius 5px
      border 1px solid $gray-tint
      height 4rem
      margin-bottom 1rem
      max-height 5.5rem
      max-width 45%
      width 45%

@media (max-width: 560px)
  .contact
    #contact-info
      flex-direction column
      margin-bottom 2rem
      .info-box:nth-child(2)
        margin-left 0

@media (max-width: 581px)
  .contact
    h2
      margin-bottom 0.5rem
    form
      flex-wrap nowrap
      height auto
      input, label, select
        width 100%
      input:nth-child(7)
        margin-bottom 0
      textarea
        max-height 100%
        max-width 100%
        width 100%
</style>
